import { ChartOptions } from './types.ts'

export type SchemaConfig = {
    shape: string
    shapeRatio: number
    size: number
    charts: ChartOptions[] // You might want to define a Chart type later
    namePlate: {
        show: boolean
        background: 'stripes' | 'none' | string
        backgroundColor: string
        titleFontColor: string
        primaryTitleText: string
        secondaryTitleText: string
        secondaryFontColor: string
        tertiaryTitleText: string
        tertiaryFontColor: string
        teamLogoId: string
        supressImage?: boolean
    }
    sourcePlate: {
        show: boolean
        background: string
        backgroundColor: string
        siteTitle: string
        siteColor: string
        sourceTitle: string
        sourceColor: string
    }
    mainPanelBackground: 'none' | string
    venueId: number
    showToolTip?: boolean
    enableZoom?: boolean
}

const defaultSchema: SchemaConfig = {
    shape: 'square',
    shapeRatio: 1,
    size: 500,
    charts: [],
    namePlate: {
        show: true,
        background: 'stripes',
        backgroundColor: '#fff',
        titleFontColor: '#000',
        primaryTitleText: '',
        secondaryTitleText: '',
        secondaryFontColor: '#a9a9a9',
        tertiaryTitleText: '',
        tertiaryFontColor: '#000',
        teamLogoId: 'primary',
    },
    sourcePlate: {
        show: true,
        background: 'none',
        backgroundColor: '#fff',
        siteTitle: 'SAVANT',
        siteColor: '#32858d',
        sourceTitle: 'SOURCE: MLB.COM',
        sourceColor: '#000',
    },
    mainPanelBackground: 'none',
    venueId: 7,
    enableZoom: false,
}

export default defaultSchema
